module.exports = __webpack_public_path__ + "static/simialr_images-0b2447fd3e3c8d1483e7d2702b269b6f.svg";